module.exports = __webpack_public_path__ + "img/noPreview.e4dccfb5.png";